function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "#ADBED0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.304 11.946C30.954 5.168 24.363.768 17.584 2.12a12.515 12.515 0 00-9.825 9.82 8.76 8.76 0 001.009 17.463h6.257a1.252 1.252 0 100-2.503H8.768a6.258 6.258 0 11.073-12.515c.638 0 1.174-.48 1.244-1.114a10.012 10.012 0 0119.891 0 1.327 1.327 0 001.318 1.114 6.257 6.257 0 110 12.515h-6.257a1.252 1.252 0 000 2.503h6.257a8.76 8.76 0 001.01-17.456z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.455 24.333a1.251 1.251 0 101.77-1.77l-5.308-5.308a1.252 1.252 0 00-1.77-.002l-.002.002-5.308 5.309a1.251 1.251 0 101.77 1.77l3.172-3.175v15.752a1.251 1.251 0 102.503 0V21.159l3.173 3.174z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v40H0z"
})));

var SvgUploading = function SvgUploading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUploading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/uploading.4ae92dbc.svg";
export { ForwardRef as ReactComponent };